class WebSocketManager {
    private isUnloading = false;

    private cleanupFunctions: (() => void)[] = [];

    private isInitialized = false;

    public initialize(): void {
        if (this.isInitialized || typeof window === 'undefined') {
            return;
        }

        this.isInitialized = true;

        const handleUnload = () => {
            this.isUnloading = true;
            this.cleanup();
        };

        const handleError = (event: ErrorEvent) => {
            const message = event.message || '';

            if (
                message.includes('Socket closed') &&
                (message.includes('1001') ||
                    message.includes('1006') ||
                    message.includes('4205') ||
                    message.includes('4408') ||
                    message.includes('Going away') ||
                    message.includes('Client Restart') ||
                    message.includes('Connection initialisation timeout'))
            ) {
                event.preventDefault();
                event.stopPropagation();

                return true;
            }

            return false;
        };

        const handleRejection = (event: PromiseRejectionEvent) => {
            const { reason } = event;
            const message = reason?.message || String(reason);

            if (
                message.includes('Socket closed') ||
                message.includes('1001') ||
                message.includes('1006') ||
                message.includes('4205') ||
                message.includes('4408') ||
                message.includes('Going away') ||
                message.includes('Client Restart') ||
                message.includes('Connection initialisation timeout')
            ) {
                event.preventDefault();
            }
        };

        window.addEventListener('beforeunload', handleUnload);
        window.addEventListener('pagehide', handleUnload);
        window.addEventListener('error', handleError);
        window.addEventListener('unhandledrejection', handleRejection);

        this.cleanupFunctions.push(() => {
            window.removeEventListener('beforeunload', handleUnload);
            window.removeEventListener('pagehide', handleUnload);
            window.removeEventListener('error', handleError);
            window.removeEventListener('unhandledrejection', handleRejection);
        });
    }

    public registerCleanup(fn: () => void): void {
        this.cleanupFunctions.push(fn);
    }

    public cleanup(): void {
        this.cleanupFunctions.forEach(fn => {
            try {
                fn();
            } catch (error) {
                console.error('Cleanup error:', error);
            }
        });
        this.cleanupFunctions = [];
    }

    public isPageUnloading(): boolean {
        return this.isUnloading;
    }
}

const wsManager = new WebSocketManager();

export default wsManager;
